import { render, staticRenderFns } from "./SGKEksikGunView.vue?vue&type=template&id=57902616&"
import script from "./SGKEksikGunView.vue?vue&type=script&lang=js&"
export * from "./SGKEksikGunView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports